import React, { useEffect, useState } from "react";
import {
  Button,
  Flex,
  Heading,
  SimpleGrid,
  Spacer
} from "@chakra-ui/react";
import { AiOutlinePlus } from "react-icons/ai";
import { useModal } from "context/modal";
import { Session } from "types/session";
import { useToast } from "hooks";
import { useCreateSession } from "repo/sessions";
import SessionForm from "./SessionForm";


const SessionsHeader: React.FC = () => {

  const { openModal, closeModal, setTitle, setContent } = useModal()!;

  const openCreateModal = () => {
    setTitle("Schedule Session");
    setContent(<SessionForm mutationFn={useCreateSession} />);
    openModal();
  };

  return (
    <SimpleGrid columns={3} w="100%">
      <Heading size="lg">Session Management</Heading>
      <Spacer />
      <Flex alignItems="center" justifyContent="flex-end">
        <Button
          size="md"
          variant="blue"
          rounded="full"
          iconSpacing={0}
          leftIcon={<AiOutlinePlus />}
          onClick={openCreateModal}
        >
          Schedule Session
        </Button>
      </Flex>
    </SimpleGrid>
  );
}

export default SessionsHeader
